import type { FC } from 'react';
import type { useProjectLedgerData } from '../_hooks/useProjectLedgerData';
import { KsProjectLedgerPage } from './KsProjectLedgerPage';
import { RsProjectLedgerPage } from './RsProjectLedgerPage';
import { SsProjectLedgerPage } from './SsProjectLedgerPage';

type Props = {
  projectId: string;
  ledgerData: ReturnType<typeof useProjectLedgerData>;
  pageId?: string;
};

/**
 * 帳票の内容を表示する共通コンポーネント
 * ProjectLedgerElementとPdfPrintWrapperから使用される
 */
export const ProjectLedgerContent: FC<Props> = ({
  projectId,
  ledgerData,
  pageId,
}) => {
  if (!ledgerData) {
    return null;
  }

  const { project } = ledgerData;

  if (!project) {
    return null;
  }

  return (
    <>
      {project.sheetType === 'RS' && (
        <RsProjectLedgerPage
          projectId={projectId}
          ledgerData={ledgerData}
          pageId={pageId}
        />
      )}
      {project.sheetType === 'SS' && (
        <SsProjectLedgerPage
          projectId={projectId}
          ledgerData={ledgerData}
          pageId={pageId}
        />
      )}
      {project.sheetType === 'KS' && (
        <KsProjectLedgerPage
          projectId={projectId}
          ledgerData={ledgerData}
          pageId={pageId}
        />
      )}
    </>
  );
};
